import React from "react";
import { useLocation } from "react-router-dom";

// Standalone product/event pages keep their own contact flows.
const EXCLUDED_PREFIXES = [
  "/ghar360",
  "/3D_Products",
  "/3d-space-announcement",
  "/BVM2026",
  "/portfolio-dashboard",
];

const WhatsAppFloat = () => {
  const { pathname } = useLocation();

  if (EXCLUDED_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
    return null;
  }

  return (
    <a
      className="whatsapp-float"
      href="https://wa.me/918377935429"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with Rionick Studios on WhatsApp"
    >
      <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
    </a>
  );
};

export default WhatsAppFloat;
